import styled from "styled-components"
import { Link } from "react-router-dom"

export const Container = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    top: 0;
    left: ${({ open }) => (open ? "0" : "-100%")};
    width: 250px;
    height: 100vh;    
    background-color: ${({ theme }) => theme.body};
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
    padding: 20px;
    gap: 10px;
    overflow-y: auto;
    transition: left 0.3s ease-in-out;
    z-index: 1200;
`

export const Backdrop = styled.div`
    display: ${({ open }) => (open ? "block" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1100;
`

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0;
`


export const SearchContainer = styled.div`
    border: 0.5px solid var(--medGrey);
    font-size: var(--fontS);
    display: flex;
    align-items: center;
    padding: 5px;
    margin: 5px 0px;

`

export const Input = styled.input`
    background-color: transparent;
    color: var(--darkGrey);
    border: none;
    width: 200px;
    transition: ease-in-out, width .35s ease-in-out;

    ::placeholder { 
        color: var(--medGrey);
    }
    
    :focus{
        outline: none;
    }
`